<script lang="ts" setup>
import MessagePrime, {
  type MessageEmits,
  type MessageProps,
  type MessageSlots,
} from 'primevue/Message'

interface Props extends /* @vue-ignore */ Omit<MessageProps, 'variant'> {
  variant?: MessageProps['variant']
  pt?: MessageProps['pt']
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface Emits extends /* @vue-ignore */ MessageEmits {}

const props = withDefaults(defineProps<Props>(), {
  variant: 'outlined',
  pt: () => ({
    content: 'flex flex-col justify-center w-full p-0',
  }),
})

defineEmits<Emits>()

const slots = defineSlots<MessageSlots>()
</script>

<template>
  <MessagePrime v-bind="props">
    <template
      v-for="(_, slot) in slots"
      #[slot]="slotData"
    >
      <slot
        :name="slot"
        v-bind="{
          class: slotData && 'class' in slotData ? slotData.class : undefined,
          closeCallback:
            slotData && 'closeCallback' in slotData ? slotData.closeCallback : () => {},
          ...slotData,
        }"
      />
    </template>
  </MessagePrime>
</template>
